/**
 * 删除 url 参数
 * options 里面的参数自行 encode
 */
export default function deleteURLSearch(url = window.location.href, key: string) {
  const urlArr = url.split('?');
  let resStr = '';
  if (urlArr[1]) {
    // extract location.search
    const searchArr = urlArr[1].split('#');
    const lists = searchArr[0].split('&');
    const obj: { [key: string]: string | number } = {};
    // eslint-disable-next-line no-restricted-syntax
    for (const i in lists) {
      const arr = lists[i].split('=');
      if (arr[0] !== key) {
        // 与 addURLSearch 的区别; 另外dealSearchStr的 options 为 {}
        obj[arr[0]] = arr[1] || '';
      }
    }
    resStr = dealSearchStr(obj, {}, searchArr[1]);
  } else {
    resStr = dealSearchStr({}, {}, urlArr[0].split('#')[1]);
  }
  return urlArr[0] + resStr;
}

const dealSearchStr = (obj = {}, options = {}, hash = '') => {
  let searchStr = '';
  const tmp: { [key: string]: string | number } = Object.assign({}, obj, options);
  let t = 0;
  // eslint-disable-next-line no-restricted-syntax
  for (const i in tmp) {
    searchStr += `${(t !== 0 ? '&' : '') + i}=${tmp[i]}`;
    t = t + 1;
  }
  if (hash) {
    // add hash #
    searchStr += `#${hash}`;
  }
  if (t !== 0) {
    // add ?
    searchStr = `?${searchStr}`;
  }
  return searchStr;
};
